import { Grid } from "@mui/material";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import useGenerateOptions, {
  useGenerateArrayFromObj,
} from "../../../../../components/input/hook/useGenerateOptions2";
import ProductWithPriceInvoice, {
  ProductWithPriceInvoiceData,
} from "../../../../../components/product/ProductWithPrice-v2";
import { useGetSuppliers } from "../../../../supplier/api/supplier/resolver";
import { useGetPaymentMethods } from "../../../api/invoice/paymentMethod/resolver";
import { useGetPurchaseInvoiceConstants } from "../../../api/invoice/purchase/constant/resolver";
import Input from "../../../../../components/input/Input-v2";
import { M_InvoicePurchaseDetail } from "../../../type/Invoice.type";
import { NonEditableTableConfig } from "../../../tableConfig/TableConfig";
import { MainContainerForm } from "../../../../../styles/Main.styles";

interface IForm {
  dataInvoice: M_InvoicePurchaseDetail;
}

export interface Form_Create_PurchaseInvoice {
  purchase_invoice_number: string;
  purchase_invoice_date: string;
  payment_method_id: string;
  purchase_invoice_status: string;
  product_list: string;
  supplier_id: string;
}

export default function FormLunas({ dataInvoice }: IForm) {
  const { control, setValue } = useForm<Form_Create_PurchaseInvoice>();
  const [keyword, setKeyword] = useState<string>();
  const { data: dataRawPaymentMethod, isLoading: fetchPaymentMethod } =
    useGetPaymentMethods({});
  const dataPaymentMethod = dataRawPaymentMethod?.data.data.data;
  const { data: dataPaymentMethodOptions } = useGenerateOptions({
    dataSource: dataPaymentMethod,
    keyForText: "payment_method_name",
    keyForValue: "id",
  });
  const { data: dataRawInvoiceConstant, isLoading: fetchInvoiceConstant } =
    useGetPurchaseInvoiceConstants();
  const dataInvoiceConstant = dataRawInvoiceConstant?.data.data.status;
  const { data: dataStatusInvoice } = useGenerateArrayFromObj({
    dataSource: dataInvoiceConstant,
  });
  const { data: dataRawSuppliers, isLoading: fetchSuppliers } = useGetSuppliers(
    { keyword }
  );
  const dataSuppliers = dataRawSuppliers?.data.data.data;
  const { data: dataSupplierOptions } = useGenerateOptions({
    dataSource: dataSuppliers,
    keyForText: "supplier_name",
    keyForValue: "id",
  });
  const [cart, setCart] = useState<ProductWithPriceInvoiceData[]>([]);
  const { body, header, lastRow } = NonEditableTableConfig(
    dataInvoice.grand_total
  );

  useEffect(() => {
    setValue("purchase_invoice_number", dataInvoice.purchase_invoice_number);
    setValue("payment_method_id", dataInvoice.payment_method_id);
    setValue("purchase_invoice_status", dataInvoice.status);
    setValue("supplier_id", dataInvoice.supplier_id);
    setCart(
      dataInvoice.purchase_invoice_detail.map((item) => {
        return {
          id: item.id,
          name: item.product.product_type_name,
          price: item.price,
          quantity: item.quantity,
          unitType: item.product.unit_type,
        };
      })
    );
  }, [dataInvoice]);

  return (
    <form>
      <MainContainerForm mb={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Input.Controller
              control={control}
              name="purchase_invoice_number"
              render={(field, fieldState) => (
                <Input.Text
                  showAsStatic
                  isFetching={fetchInvoiceConstant}
                  label="Nomor Invoice"
                  value={field.value}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="purchase_invoice_status"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Select
                  showAsStatic
                  isFetching={fetchInvoiceConstant}
                  label="Status"
                  options={dataStatusInvoice}
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="payment_method_id"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Select
                  showAsStatic
                  isFetching={fetchPaymentMethod}
                  label="Metode Pembayaran"
                  options={dataPaymentMethodOptions}
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="supplier_id"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Autocomplete
                  showAsStatic
                  isFetching={fetchSuppliers}
                  label="Supplier"
                  options={dataSupplierOptions}
                  value={field.value}
                  onClick={(e) => field.onChange(e.value)}
                  onChange={(e) => setKeyword(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
        </Grid>
      </MainContainerForm>
      <MainContainerForm>
        <Grid container>
          <Grid item xs={12} md={12}>
            <Input.Controller
              control={control}
              name="product_list"
              render={(field) => (
                <ProductWithPriceInvoice
                  body={body}
                  header={header}
                  lastRowRender={lastRow}
                  onChange={(e) => field.onChange(e)}
                  dataProduct={cart}
                />
              )}
            />
          </Grid>
        </Grid>
      </MainContainerForm>
    </form>
  );
}
